
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round","d":"M15.5 11.982v2.107a1.4 1.4 0 0 1-.957 1.337 1.4 1.4 0 0 1-.578.068 13.95 13.95 0 0 1-6.075-2.156 13.7 13.7 0 0 1-4.223-4.216 13.9 13.9 0 0 1-2.161-6.09 1.4 1.4 0 0 1 .833-1.412 1.4 1.4 0 0 1 .568-.12h2.111a1.41 1.41 0 0 1 1.408 1.208c.09.675.255 1.337.493 1.974a1.4 1.4 0 0 1-.317 1.483l-.894.892a11.25 11.25 0 0 0 4.224 4.215l.894-.892a1.41 1.41 0 0 1 1.485-.316 9 9 0 0 0 1.978.492 1.41 1.41 0 0 1 1.21 1.426"}})])
          )
        }
      }
    